/**
 * Review page — component files:
 * - workspace/js/review/testimonials.js
 */
